import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatTableDataSource, TooltipPosition } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { UserSessionService } from 'services/usersession.service';
import { SupportStatusComponent } from '../support-status/support-status.component';
import * as moment from 'moment-timezone';
import { ExcelService } from 'services/excel.service';
import { DatePipe } from '@angular/common';
import { AlertService } from 'services/alert.service';
import { error } from 'console';

@Component({
  selector: 'app-support-ticket-admin',
  templateUrl: './support-ticket-admin.component.html',
  styleUrls: ['./support-ticket-admin.component.scss']
})
export class SupportTicketAdminComponent implements OnInit {

  supportForm: FormGroup;
  isTooltipOpen = false;
  internetAccDetailsForm: FormGroup;
  logForm: FormGroup;
  userID: number = 0;
  roleDetailsEnum: any;
  filterValue: string;
  homeLanguage: number;
  data: any;
  filteredList: any[];
  toShow = false;
  listFound: any = null;
  isSubmitted = false;
  hide = true;
  supportList: any[];
  getroleDetailsList: [] = [];
  showCustomer: boolean;
  makeQueryExpand = false;
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  sessionDataString: any;
  excelColumns: string[];
  dataExcel: any;
  pipe = new DatePipe('en-US');
  searchQuery: string;
  maskedFullName: string;
  showFilter = false;
  filterOpen = false;
  toMinDate: any;

  constructor(
    private formBuilder: FormBuilder,
    private userServices: UserService,
    private excelService: ExcelService,
    private session: UserSessionService,
    private navigate: NavigationService,
    public dialog: MatDialog,
    private alertService: AlertService,
    private toastr: ToastrService,
  ) {
    this.initialValidator();
  }

  ngOnInit(): void {
    this.load("");
  }

  initialValidator() {
    this.supportForm = this.formBuilder.group({
      searchQuery: [''],
      fromDate: [null, Validators.required],
      toDate: [{ value: null, disabled: true }, Validators.required]
    })
  }
  today = new Date();
  toMaxDate = new Date();

  dateChangeEvent() {
    this.isSubmitted = false;

    var fromControl = this.supportForm.get('fromDate');
    var toControl = this.supportForm.get('toDate');

    if (fromControl && fromControl.value) {
      this.toMinDate = new Date(fromControl.value);
      this.toMinDate.setHours(0, 0, 0, 0);

      toControl.enable();
      toControl.reset();
    } else {
      toControl.disable();
    }
  }

  onToDateChange() {
    var toCtrl = this.supportForm.controls['toDate'];
    this.isSubmitted = false;
    toCtrl.markAsTouched();
    toCtrl.markAsDirty();
    toCtrl.updateValueAndValidity();
  }

  toggleFilter() {
    this.filterOpen = !this.filterOpen;
    if (!this.filterOpen) {
      this.isSubmitted = false;
      this.supportForm.reset();
    }
  }

  clearFilter() {
    this.isSubmitted = false;
    // this.supportForm.patchValue({
    //   fromDate: null,
    //   toDate: null
    // });
    this.supportForm.reset();
  }

  getAllQContactTicketsBySearch() {
    const searchQuery = (this.supportForm.value.searchQuery || '').trim();
    if (searchQuery == null || searchQuery == '') {
      this.alertService.warning("Please enter a search query");
      return;
    }
    this.load(searchQuery);
  }

  load(searchText: string) {
    const formValue = this.supportForm.value;
    const searchQuery = searchText;

    let from: Date | undefined;
    let to: Date | undefined;

    if (formValue.fromDate) {
      from = new Date(formValue.fromDate);
      from.setHours(0, 0, 0, 0);
    }

    if (formValue.toDate) {
      to = new Date(formValue.toDate);
      to.setHours(23, 59, 59, 999);
    }

    this.userServices.getAllTickets(searchQuery, from, to).subscribe(
      (data: any) => {
        if (data && data.isSuccess) {
          this.supportList = data.value || [];
          this.dataExcel = this.supportList;
          this.listFound = this.supportList.length > 0;
        } else {
          this.supportList = [];
          this.listFound = false;
        }
      },
      () => {
        this.supportList = [];
        this.listFound = false;
      }
    );
  }


  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.getAllQContactTicketsBySearch();
    }
  }

  applyFilter() {
    this.isSubmitted = true;
    if (this.supportForm.invalid) {
      return;
    }
    this.load("");
  }

  Refresh() {
    this.supportForm.reset()
    this.load("")
  }

  exportAsXLSX() {
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.info("No data available to export");
        return;
      }
      const excelList = [];
      this.excelColumns = [
        'Date',
        'Reference Number',
        'Name',
        'Subject',
        'Category',
        'Status',
        'Comments',
      ];
      exportData.forEach((a, index) => {
        let fullName = this.encryptionname(a.fullName);
        excelList.push({
          'Date': moment(a.creationTs).format("YYYY-MM-DD HH:MM:SS"),
          'Reference Number': a.referenceNumber,
          'Name': fullName,
          'Subject': a.subject,
          'Category': a.supportCategoryTypeName,
          'Status': a.ticketStatusTypeName,
          'Comments': a.supportComments,
        });
      });
      this.excelService.exportAsExcelFile(
        excelList,
        "Support Ticket Details",
        this.excelColumns
      );
    }, 500);
  }

  encryptionname(name: string): string {
    const nameParts = name.split(" ");
    let maskedName = nameParts.map(part => {
      if (part.length > 2) {
        return part.substring(0, 2) + 'xxx';
      } else {
        return part;
      }
    }).join(" ");
    return maskedName;
  }

}



